import React from 'react';
import {
    Responsive,
    SimpleList,
    SimpleShowLayout,
    Datagrid,
    SimpleForm,
    TextField,
    BooleanField,
    TextInput,
    SelectInput,
    DisabledInput,
    required
} from 'admin-on-rest';
import {DependentInput} from 'aor-dependent-input';
import List from '../admin/ListStatic';
import Show from '../admin/Show';
import Create from '../admin/Create';
import Edit from '../admin/Edit';
import ValidatedInputField from '../components/ValidatedInputField';
import AccessTable from '../components/AccessTable';
import ViewButton from '../buttons/ViewButton';
import EditButton from '../buttons/EditButton';
import TooltipIcon from '../components/TooltipIcon';
import ReactTooltip from 'react-tooltip';
import {passwordValidation, passwordChangeValidation} from "../shared/validation";
import Avatar from 'material-ui/Avatar';
import Icon from 'material-ui/svg-icons/social/person-outline';
import FuseTheme from "../global/theme";

export const fuseSysAdminIcon = Icon;

const styles = {
    accessBox: {
        display: 'block',
        padding: '4px 10px 4px 10px',
        border: '1px solid ' + FuseTheme.palette.lightTextColor,
        boxSizing: 'border-box',
    },
    avatar: {backgroundColor: "#6e6e6e", width: 40, height: 40, marginRight: 10, verticalAlign: 'bottom'},
    description: {lineHeight: 1.5},
    row: {display: 'flex', justifyContent: 'space-between'},
    rowField: {flex: '0 1 30%', display: 'inline-block', margin: '0 1em 0 0', verticalAlign: 'top'},
    rowShowField: {display: 'inline-block', width: 'auto', minWidth: 100, margin: '0 1em 0 0', verticalAlign: 'top'},
    fieldSmall: {flex: '0 1 10%', display: 'inline-block', maxWidth: '8.5em', overflow: 'hidden'},
    fieldHeader: {
        display: 'block',
        width: '100%',
        fontSize: '16px',
        fontWeight: 'bold',
        color: FuseTheme.palette.lightTextColor,
        margin: '2em 0 0 0',
    },
    fieldInstructions: {
        display: 'block',
        width: '100%',
        fontSize: '14px',
        fontWeight: 'bold',
        color: FuseTheme.palette.lightTextColor,
        margin: '2em 0 2em 0',
    },
    fieldLabel: {
        display: 'block',
        width: '100%',
        fontSize: '14px',
        color: FuseTheme.palette.lightTextColor,
        margin: '2em 0 0 0',
    },
    fieldDescription: {
        flex: '1 1 40%',
        display: 'inline-block',
        width: 'auto',
        height: '2em',
        fontSize: '12px',
        color: FuseTheme.palette.lightTextColor,
        verticalAlign: 'bottom',
    },
    divider: {
        display: 'block',
        width: '100%',
        height: 1,
        backgroundColor: FuseTheme.palette.primary3Color,
        border: 'none',
        margin: '1em 0 0.5em 0'
    },
    hidden: {display: 'none'},
    break: {display: 'block', width: '100%', height: 0, border: 'none', margin: 0},
    paddingBottom: {paddingBottom: '1em'},
};

// Handle event from access Add
const handleAddAccess = (e, index, value) => {
};

// Handle event from access Remove
const handleRemoveAccess = (e) => {
};

const MakeAccessTable = ({record, type, showButtons, clearAccess}) => {
    let accessAll = false;
    let accessList = [];
    let optionText = 'name';
    if (type.listName === 'systems') {
        accessAll = (type.edit) ? false : record.systems_all;
        accessList = (record.systems && !clearAccess) ? record.systems : [];
    }
    return (
        <AccessTable
            {...record}
            key={`access-table-${record.email}`}
            listName={type.listName}
            name={type.name}
            single={type.single}
            accessAll={accessAll}
            accessList={accessList}
            clearAccess={clearAccess}
            onAddUpdate={handleAddAccess}
            onRemoveUpdate={handleRemoveAccess}
            optionText={optionText}
            showAdd={showButtons.add}
            showRemove={showButtons.remove}/>
    )
};

const validatePassword = [required, passwordValidation];
const validateChangePassword = [passwordChangeValidation];

/*
 * View: List
 */

// Set title for List Sysadmins
const ListTitle = <span><Avatar icon={<Icon/>} style={styles.avatar}
                                className="avatar-title"/>System Administrators</span>;

const ListDescription = () => {
    return (
        <span style={styles.description}>
            <p>A System Admin (Sysadmin) is a user of the Admin. A Sysadmin account may have access to all Systems or
                be provided access to selected Systems. Sysadmins can fully access the CloudSent Admin and Reports for
                their Systems. They have the ability to create, view, edit, and delete POS Users.</p>
            <p>Sysadmins cannot create Systems or other Sysadmins.</p>
        </span>
    );
};

/*
 * List Sysadmins table
 */
export const fuseSystemAdminList = (props) => (
    <List {...props} title={ListTitle} desc={<ListDescription/>} sort={{field: 'email', order: 'ASC'}}
          perPage={20} filter={{role: 'sys_admin'}}>
        <Responsive
            small={
                <SimpleList
                    primaryText={record => record.email}
                    secondaryText={record => record.first_name + '  ' + record.last_name}
                    tertiaryText={record => record.active}
                />
            }
            medium={
                <Datagrid bodyOptions={{stripedRows: false, showRowHover: true}}>
                    <TextField source="email" label="Email"/>
                    <TextField source="first_name" label="First Name"/>
                    <TextField source="last_name" label="Last Name"/>
                    <BooleanField source="systems_all" label="All Systems"/>
                    <BooleanField source="active" label="Active"/>
                    <ViewButton/>
                    <EditButton/>
                </Datagrid>
            }
        />
    </List>
);

/*
 * View: Show
 */

// Set title for Show Sysadmin
const ShowTitle = ({record}) => {
    let firstName, lastName;
    if (record) {
        firstName = (record.sys_first_name) ? record.sys_first_name : record.first_name;
        lastName = (record.sys_last_name) ? record.sys_last_name : record.last_name;
    }
    return <span><Avatar icon={<Icon/>} style={styles.avatar}
                         className="avatar-title"/>{record ? `${firstName} ${lastName}` : 'Sysadmin'}</span>;
};

const ShowDescription = () => {
    return (
        <span style={styles.description}>
            <p>Review user details below. To edit this Sysadmin, click <strong>Edit</strong> above.</p>
        </span>
    );
};

/*
 * Show Sysadmin Table
 */
export const fuseSystemAdminShow = (props) => (
    <Show title={<ShowTitle/>} desc={<ShowDescription/>} {...props}>
        <SimpleShowLayout>
            <TextField source="sys_email" label="Email"/>
            <TextField source="sys_first_name" label="First Name"/>
            <TextField source="sys_last_name" label="Last Name"/>
            <BooleanField source="sys_op" label="Sysop" elStyle={styles.fieldSmall}/>
            <BooleanField source="sys_admin" label="Sysadmin" elStyle={styles.fieldSmall}/>
            <BooleanField source="active" label="Active" style={styles.rowShowField} elStyle={styles.fieldSmall}/>
            <BooleanField source="locked" label="Locked" style={styles.rowShowField} elStyle={styles.fieldSmall}/>
            <span style={styles.fieldHeader}>Permissions</span>
            <BooleanField source="systems_all" label="All Systems" style={styles.rowShowField}
                          elStyle={styles.fieldSmall}/>
            {<MakeAccessTable
                type={{listName: 'systems', name: 'Systems', single: 'System', edit: false}}
                showButtons={{'add': false, 'remove': false}}
            />}
        </SimpleShowLayout>
    </Show>
);

/*
 * View: Create form
 */

// Set title for Create Sysadmin
const CreateTitle = <span><Avatar icon={<Icon/>} style={styles.avatar}
                                  className="avatar-title"/>Create a Sysadmin</span>;

const CreateDescription = () => {
    return (
        <span style={styles.description}>
            <p>A System Admin (Sysadmin) is a user of the Admin. A Sysadmin account may have access to all Systems or
                be provided access to selected Systems. Sysadmins can fully access the CloudSent Admin and Reports for
                their Systems. They have the ability to create, view, edit, and delete POS Users.</p>
            <p>Sysadmins cannot create Systems or other Sysadmins.</p>
            <p>Enter the required fields below.</p>
        </span>
    );
};

// Set defaults for Create form
const defaultCreateValues = {
    active: false,
    locked: false,
    sys_op: false,
    sys_admin: true,
    systems_all: true,
    systems: [],
    sections_all: true,
    sections: [],
    locations_all: true,
    locations: [],
    dbas_all: true,
    dbas: [],
    districts_all: true,
    districts: [],
};

/*
 * Create Sysadmin form
 */
export const fuseSystemAdminCreate = (props) => (
    <Create {...props} title={CreateTitle} desc={<CreateDescription/>}>
        <SimpleForm defaultValue={defaultCreateValues} submitOnEnter={false} redirect="list">

            <hr style={{...styles.break, ...styles.paddingBottom}}/>
            <span style={styles.fieldDescription}>
                Enter and verify a unique <strong>Email Address</strong> for this Sysadmin.
            </span>
            <ValidatedInputField
                formName="record-form"
                source="sys_email"
                fieldType="email"
                label="Email Address*"
                buttonLabel="Check Availability"
                successMessage="This Email is available."
                errorDuplicateMessage="A User with this Email already exists."
                errorRequiredMessage="A unique Email is required."
                fieldResource="Sysadmins"
                isRequired={true}
            />
            <TextInput source="sys_password" label="Password" type="password" validate={validatePassword}/>
            <TextInput source="sys_confirm_password" label="Confirm Password" type="password"
                       validate={validatePassword}/>
            <TextInput source="sys_first_name" label="First Name" validate={[required]} style={styles.rowShowField}/>
            <TextInput source="sys_last_name" label="Last Name" validate={[required]} style={styles.rowShowField}/>
            <hr style={styles.break}/>

            <span style={styles.fieldLabel}>
                Sysadmin is Active*
                <TooltipIcon dataFor="ttActive"/>
                <ReactTooltip id="ttActive" type="light" effect="solid" multiline={true} border={true}
                              className="tooltip">
                    If <em>Active</em>, this Sysadmin account can access and modify Users and Systems.
                    <br/>
                    If <em>Inactive</em>, this Sysadmin account cannot access or modify Users and Systems.
                </ReactTooltip>
            </span>
            <SelectInput source="active"
                         validate={[required]}
                         choices={[
                             {id: true, name: 'Active'},
                             {id: false, name: 'Inactive'},
                         ]}
                         options={{
                             floatingLabelText: '',
                         }}
            />

            <span style={styles.fieldHeader}>Access and Permissions</span>
            <hr style={{...styles.break, ...styles.paddingBottom}}/>
            <span style={styles.fieldDescription}>Sysadmins have access to all Systems, Admin Sections, Store
                Locations, DBAs and Districts by default. You may restrict this account to access only specific
                areas by selecting <em>False</em> and adding access from the available lists.</span>

            <span style={styles.fieldLabel}>
                Sysadmin can access all Systems*
                <TooltipIcon dataFor="ttAllSystems"/>
                <ReactTooltip id="ttAllSystems" type="light" effect="solid" multiline={true} border={true}
                              className="tooltip">
                    If <em>True</em>, this Sysadmin account can access all Systems.
                    <br/>
                    If <em>False</em>, this Sysadmin account can access specific Systems.
                    <br/><br/>
                    Available Systems should be selected from the list if set to false.
                </ReactTooltip>
            </span>
            <SelectInput source="systems_all" validate={[required]} options={{floatingLabelText: ''}}
                         choices={[
                             {id: true, name: 'True'},
                             {id: false, name: 'False'},
                         ]}/>
            <DependentInput dependsOn="systems_all" value={false}>
                {<MakeAccessTable
                    type={{listName: 'systems', name: 'Systems', single: 'System', edit: false}}
                    showButtons={{'add': true, 'remove': true}}
                    clearAccess={true}
                />}
            </DependentInput>

            {/* FPO; Locations/DBAs/Districts are set to true and sections are all */}
            <DependentInput dependsOn="systems_all" value={null}>

            <span style={styles.fieldLabel}>
                Sysadmin can access all Sections*
                <TooltipIcon dataFor="ttAllSections"/>
                <ReactTooltip id="ttAllSections" type="light" effect="solid" multiline={true} border={true}
                              className="tooltip">
                    If <em>True</em>, this Sysadmin account can access all sections of the Admin.
                    <br/>
                    If <em>False</em>, this Sysadmin account can access specific sections of the Admin.
                    <br/><br/>
                    Available Sections should be selected from the list if set to false.
                </ReactTooltip>
            </span>
                <SelectInput source="sections_all" validate={[required]} options={{floatingLabelText: ''}}
                             choices={[
                                 {id: true, name: 'True'},
                                 {id: false, name: 'False'},
                             ]}/>

                <span style={styles.fieldLabel}>
                Sysadmin can access all Locations*
                <TooltipIcon dataFor="ttAllLocations"/>
                <ReactTooltip id="ttAllLocations" type="light" effect="solid" multiline={true} border={true}
                              className="tooltip">
                    If <em>True</em>, this Sysadmin account can access all Store Locations.
                    <br/>
                    If <em>False</em>, this Sysadmin account can access specific Store Locations.
                    <br/><br/>
                    Available Locations should be selected from the list if set to false.
                </ReactTooltip>
            </span>
                <SelectInput source="locations_all" validate={[required]} options={{floatingLabelText: ''}}
                             choices={[
                                 {id: true, name: 'True'},
                                 {id: false, name: 'False'},
                             ]}/>

                <span style={styles.fieldLabel}>
                Sysadmin can access all DBAs*
                <TooltipIcon dataFor="ttAllDBAs"/>
                <ReactTooltip id="ttAllDBAs" type="light" effect="solid" multiline={true} border={true}
                              className="tooltip">
                    If <em>True</em>, this Sysadmin account can access all DBAs.
                    <br/>
                    If <em>False</em>, this Sysadmin account can access specific DBAs.
                    <br/><br/>
                    Available DBAs should be selected from the list if set to false.
                </ReactTooltip>
            </span>
                <SelectInput source="dbas_all" validate={[required]} options={{floatingLabelText: ''}}
                             choices={[
                                 {id: true, name: 'True'},
                                 {id: false, name: 'False'},
                             ]}/>

                <span style={styles.fieldLabel}>
                Sysadmin can access all Districts*
                <TooltipIcon dataFor="ttAllDistricts"/>
                <ReactTooltip id="ttAllDistricts" type="light" effect="solid" multiline={true} border={true}
                              className="tooltip">
                    If <em>True</em>, this Sysadmin account can access all Districts.
                    <br/>
                    If <em>False</em>, this Sysadmin account can access specific Districts.
                    <br/><br/>
                    Available Districts should be selected from the list if set to false.
                </ReactTooltip>
            </span>
                <SelectInput source="districts_all" validate={[required]} options={{floatingLabelText: ''}}
                             choices={[
                                 {id: true, name: 'True'},
                                 {id: false, name: 'False'},
                             ]}/>
            </DependentInput>

            <span style={styles.fieldInstructions}>
                After clicking <strong>Save</strong>, you will be redirected to the Sysadmins List.
            </span>
            <hr style={{...styles.break, ...styles.paddingBottom}}/>
        </SimpleForm>
    </Create>
);

/*
 * View: Edit form
 */

// Set title for Edit Sysadmin
const EditTitle = ({record}) => {
    let firstName, lastName;
    if (record) {
        firstName = (record.sys_first_name) ? record.sys_first_name : record.first_name;
        lastName = (record.sys_last_name) ? record.sys_last_name : record.last_name;
    }

    return <span><Avatar icon={<Icon/>} style={styles.avatar}
                         className="avatar-title"/>Edit {record ? `${firstName} ${lastName}` : 'Sysadmin'}</span>;
};

const EditDescription = () => {
    return (
        <span style={styles.description}>
            <p>Modify fields in the tabs below. Click <strong>Save</strong> to store this Sysadmin's details.</p>
        </span>
    );
};

/*
 * Edit Sysadmin form
 */
export const fuseSystemAdminEdit = (props) => (
    <Edit {...props} title={<EditTitle/>} desc={<EditDescription/>}>
        <SimpleForm submitOnEnter={false}>
            <DisabledInput source="sys_email" label="Email"/>
            <span style={styles.fieldDescription}>
                Email cannot be edited.
                <TooltipIcon dataFor="ttEmail"/>
                <ReactTooltip id="ttEmail" type="light" effect="solid" multiline={true} border={true}
                              className="tooltip">
                    Email addresses must be unique within the system. A Sysadmin's email cannot be edited.
                </ReactTooltip>
            </span>
            <hr style={styles.break}/>
            <TextInput source="sys_first_name" label="First Name" validate={[required]} style={styles.rowShowField}/>
            <TextInput source="sys_last_name" label="Last Name" validate={[required]} style={styles.rowShowField}/>
            <hr style={styles.break}/>

            <span style={styles.fieldLabel}>
                Sysadmin can access all Systems*
                <TooltipIcon dataFor="ttAllSystems"/>
                <ReactTooltip id="ttAllSystems" type="light" effect="solid" multiline={true} border={true}
                              className="tooltip">
                    If <em>True</em>, this Sysadmin account can access all Systems.
                    <br/>
                    If <em>False</em>, this Sysadmin account can access specific Systems.
                    <br/><br/>
                    Available Systems should be selected from the list if set to false.
                </ReactTooltip>
            </span>
            <SelectInput source="systems_all" validate={[required]}
                         options={{floatingLabelText: ''}}
                         choices={[
                             {id: true, name: 'True'},
                             {id: false, name: 'False'},
                         ]}
            />
            <DependentInput dependsOn="systems_all" value={false}>
                {<MakeAccessTable
                    type={{listName: 'systems', name: 'Systems', single: 'System', edit: true}}
                    showButtons={{'add': true, 'remove': true}}
                />}
            </DependentInput>

            <span style={styles.fieldLabel}>
                Sysadmin is Active*
                <TooltipIcon dataFor="ttActive"/>
                <ReactTooltip id="ttActive" type="light" effect="solid" multiline={true} border={true}
                              className="tooltip">
                    If <em>Active</em>, this Sysadmin account can access and modify Users.
                    <br/>
                    If <em>Inactive</em>, this Sysadmin account cannot access or modify Users.
                </ReactTooltip>
            </span>
            <SelectInput source="active"
                         validate={[required]}
                         choices={[
                             {id: true, name: 'Active'},
                             {id: false, name: 'Inactive'},
                         ]}
                         options={{
                             floatingLabelText: '',
                         }}
            />

            <span style={styles.fieldLabel}>
                Lock this Sysadmin Account
                <TooltipIcon dataFor="ttLocked"/>
                <ReactTooltip id="ttLocked" type="light" effect="solid" multiline={true} border={true}
                              className="tooltip">
                    If <em>Locked</em>, this Sysadmin account cannot access the Admin.
                </ReactTooltip>
            </span>
            <SelectInput source="locked"
                         validate={[required]}
                         choices={[
                             {id: true, name: 'Account is Locked'},
                             {id: false, name: 'Account is not Locked'},
                         ]}
                         options={{
                             floatingLabelText: '',
                         }}
            />

            <hr style={{...styles.break, ...styles.paddingBottom}}/>

            <span style={styles.fieldLabel}>
                Change Sysadmin Password (if desired):
                <TooltipIcon dataFor="ttPass"/>
                <ReactTooltip id="ttPass" type="light" effect="solid" multiline={true} border={true}
                              className="tooltip">
                    Modify these fields only if you wish to save a new password.
                </ReactTooltip>
            </span>
            <TextInput source="sys_new_password" label="Change Password" type="password"
                       validate={validateChangePassword}/>
            <TextInput source="sys_confirm_new_password" label="Confirm Change Password" type="password"
                       validate={validateChangePassword}/>

            <span style={styles.fieldInstructions}>
                After clicking <strong>Save</strong>, you will be redirected to the Sysadmins List.
            </span>
            <hr style={{...styles.break, ...styles.paddingBottom}}/>
        </SimpleForm>
    </Edit>
);



// WEBPACK FOOTER //
// ./src/Fuse/System/sysAdmin.js